import { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import ReactPaginate from 'react-paginate';  // Import the paginate component
import './style.css';
import "./orders.css";  // Import the CSS file

const OrdersAdmin = () => {
    const [orders, setOrders] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [newGain, setNewGain] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
const normalizeText = (text) => text.normalize("NFC").toLowerCase();

    useEffect(() => {
        checkAdminStatus();
    }, []);

    useEffect(() => {
        if (isAdmin) {
            fetchAllOrders(currentPage + 1);  // Fetch orders based on the current page (pagination)
        }
    }, [isAdmin, currentPage]);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1'; 
        setIsAdmin(isAdmin);

        if (isAdmin) {
            fetchAllOrders(currentPage + 1);  // Fetch orders when admin status is verified
        } else {
            console.error('Unauthorized: User is not an admin');
        }
    };

    const fetchAllOrders = async (page) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }

            const response = await axios.get(`https://hbmdijital.online/api/admin/orders?page=${page}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                setOrders(response.data.data);  // Response data with paginated orders
                setPageCount(response.data.last_page);  // Total number of pages
            } else {
                console.error('Failed to fetch orders:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching orders:', error);
        }
    };

    const handleStatusChange = async (orderID, newStatus, paymentStatus) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }

            const response = await axios.put(
                `https://hbmdijital.online/api/admin/orders/${orderID}/tracking`, 
                { CurrentStatus: newStatus },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response.status === 200) {
                fetchAllOrders(currentPage + 1);  // Re-fetch orders after status update
            } else {
                console.error('Failed to update order status:', response.statusText);
            }
        } catch (error) {
            console.error('Error updating order status:', error);
        }
    };

    const handlePageChange = (selectedPage) => {
        setCurrentPage(selectedPage.selected);
    };

    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }
const getStatusClass = (status) => {

    const normalizedStatus = normalizeText(status);

    if (normalizedStatus === "livr�") return "row-livre";
    if (normalizedStatus === "annul�") return "row-annule";
    return "";
};


    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex">
                <section className="w-100 p-3">
                    <h1 className="text-dark display-4">Tableau de bord de l'administrateur</h1>
                    <hr className="my-4" />

                    {/* Orders Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th>ID de commande</th>
                                    <th>Fournisseur</th>
                                    <th>Client</th>
                                    <th>Statut du paiement</th>
                                    <th>Produits</th>
                                    <th>Montant</th>
                                    <th>Gain</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order) => (
        <tr key={order.OrderID} className={getStatusClass(order.status)}>
                                      <td>{order.OrderID}</td>
                                        <td>{order.supplier.name}</td>
                                        <td>{order.customer_info.Name}</td>
                                        <td>{order.payment.PaymentStatus}</td>
                                        <td>
                                            {order.order_items.map((item) => (
                                                <div key={item.OrderItemID}>{item.product.Name}</div>
                                            ))}
                                        </td>
                                        <td>{order.payment.Amount} DH</td>
                                        <td>{order.gain} DH</td>
                                        <td>
                                            <select
                                                value={order.status}
                                                onChange={(e) => handleStatusChange(order.OrderID, e.target.value, order.payment.PaymentStatus)}
                                                className="form-control"
                                                disabled={order.status === 'livré' || order.status === 'annulé'}
                                            >
                                                <option value="en attente">En attente</option>
                                                <option value="attribué">Attribué</option>
                                                <option value="en transit">En transit</option>
                                                <option value="livré">Livré</option>
                                                <option value="annulé">Annulé</option>
                                            </select>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex justify-content-center">
                        <ReactPaginate
                            previousLabel={"← Précédent"}
                            nextLabel={"Suivant →"}
                            breakLabel={"..."}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageChange}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            disabledClassName={"disabled"}
                        />
                    </div>
                    {/* Admin Instructions */}
                    <div className="alert alert-info mt-4">
                        <h5>Instructions pour l'admin :</h5>
                        <ul>
                            <li>Une commande ne peut pas être marquée comme "Livré" si le paiement est "not payé".</li>
                            <li>Le bouton "Modifier" est désactivé tant que la commande n'est pas "Livré".</li>
                        </ul>
                    </div>
                </section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default OrdersAdmin;
